import style from './StatusIcon.module.scss';
import { NOTE_STATUS } from '@ax/constants';
import sentToMdsIcon from '@image/sent-to-mds-icon.svg';
import inEHRIcon from '@image/in-ehr-icon.svg';
import noteProcessingIcon from '@image/note-processing-icon.svg';
import noteGeneratedIcon from '@image/note-generated-icon.svg';

interface StatusIconProps {
  status?: number | null;
}

const StatusIcon = ({ status }: StatusIconProps) => {
  const uploadedToMds = status === NOTE_STATUS.NOTE_UPLOADED_TO_MDS;
  const uploadedToEhr = status === NOTE_STATUS.NOTE_UPLOADED_TO_EHR;
  const draftNoteProcessing = status === NOTE_STATUS.CONTENT_PROCESSING;
  const draftNoteReady = status === NOTE_STATUS.NOTE_READY;

  return (
    <>
      {
        <div className={style.status__icon__container}>
          {
            <>
              {uploadedToMds && (
                <span className={style.status__icon__item}>
                  {
                    <img
                      className={style.status__icon__img}
                      src={sentToMdsIcon}
                      height={16}
                      width={16}
                      alt="Sent to MDS"
                    />
                  }
                  {<span className={style.status__icon__text}>Sent to MDS</span>}
                </span>
              )}
              {draftNoteProcessing && (
                <span className={style.status__icon__item}>
                  {
                    <img
                      className={style.status__icon__img}
                      src={noteProcessingIcon}
                      height={16}
                      width={16}
                      alt={'Processing'}
                    />
                  }
                  {<span className={style.status__icon__text}>Processing</span>}
                </span>
              )}
              {draftNoteReady && (
                <span className={style.status__icon__item}>
                  {
                    <img
                      className={style.status__icon__img}
                      src={noteGeneratedIcon}
                      height={16}
                      width={16}
                      alt={'Generated'}
                    />
                  }
                  {<span className={style.status__icon__text__generated}>Generated</span>}
                </span>
              )}
              {uploadedToEhr && (
                <span className={style.pill__icon__container}>
                  {
                    <img
                      className={style.status__pill__icon__img}
                      src={inEHRIcon}
                      height={16}
                      width={16}
                      alt={'In EHR'}
                    />
                  }
                  {<span className={style.pill__icon__text}>In EHR</span>}
                </span>
              )}
            </>
          }
        </div>
      }
    </>
  );
};

export default StatusIcon;
